import { Tooltip } from "antd-v5";
import InternalLink from "components/InternalLink";
import { useActiveUserContext } from "contexts/ActiveUserContext";
import { omit } from "lodash";
import React, { MouseEvent } from "react";

import ACLink from "ac-components/ACLink/ACLink";
import ACButton from "ac-components/ac-button/ACButton";
import RedirectIcon from "ac-components/ac-icons/RedirectIcon";

export default function FindingIdCell({
  id,
  showFindingDetail,
  index,
}: {
  id: string;
  showFindingDetail: (e: MouseEvent<HTMLAnchorElement>) => void;
  index?: number;
}) {
  const { tenantId, businessUnitId, sessionData } = useActiveUserContext();
  return (
    <div className="ac-finding-id-icon-container">
      <InternalLink
        to={`/findings/${id}`}
        component={(props) => (
          <ACLink
            {...omit(props, ["navigate"])}
            data-id={id}
            data-index={index}
            onClick={(e) => {
              if (isModifiedEvent(e)) return;
              e.preventDefault();
              showFindingDetail(e);
            }}
            className="ac-finding-id"
          />
        )}
      >
        {id}
      </InternalLink>
      {!sessionData?.nonRegisteredUser ? (
        <Tooltip title="Open finding in new tab">
          <ACButton
            type="outline"
            size="sm"
            iconOnly
            className="ac-finding-icon"
          >
            <a
              href={`#/findings/${tenantId}/${businessUnitId}/${id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <RedirectIcon />
            </a>
          </ACButton>
        </Tooltip>
      ) : null}
    </div>
  );
}

export const isModifiedEvent = (e: React.MouseEvent) =>
  e.button === 1 || e.metaKey || e.ctrlKey;
